import React, { useEffect } from 'react';
import ValidationStore, { addValidation } from 'lib/stores/validationStore';
import ModalStore, { closeModal, openModal } from 'lib/stores/modalStore';
import Form from 'lib/components/Form';
import Modal from 'lib/components/Modal';

const Contract = ({ contract, page = 'registration' }) => {
  const { open } = ModalStore.useState(state => state[`contract${contract.id}Modal`]);
  const modal = `contract${contract.id}`;
  const validationKey = `contract_${contract.id}`;
  const { valid = false } = ValidationStore.useState(state => state[page][validationKey] || {});

  const onClick = () => {
    if (!valid) return ModalStore.update(state => openModal(state, modal));

    ValidationStore.update(s => { addValidation(s, validationKey, false); });
  };

  const onAccept = () => {
    ModalStore.update(state => closeModal(state, modal));

    ValidationStore.update(s => { addValidation(s, validationKey, true); });
  };

  const onClose = () => {
    ModalStore.update(state => closeModal(state, modal));
  };

  useEffect(() => {
    ValidationStore.update(s => { addValidation(s, validationKey, false); });
  }, []);

  return (
    <>
      <Form.Checkbox
        name={contract.id}
        label={`Check here to read and accept our ${contract.title}`}
        value={valid}
        handleChange={onClick}
        id={contract.id}
        useLocale={false}
        checked={valid}
        required
      />
      <Modal
        title={contract.title}
        content={contract.content}
        onClose={onClose}
        open={open}
        onAccept={onAccept}
        acceptMessage={contract.agree_message}
        name={contract.id}
        id={`contract${contract.id}Modal`}
      />
    </>
  );
};

export default Contract;
